import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=4024eaa2&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=4024eaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024eaa2",
  null
  
)

export default component.exports